<!-- <app-spinner></app-spinner> -->

<div class="voucher">
  <div class="voucher__header">
    <flame-icon class="voucher__icon-radio" svgIcon="radio-active" size="xs"></flame-icon>
    <span class="voucher__title">
      @if (isRechargeSchedule && confirmRechargeSchedule) {
        {{ textTokens.TICKET_TITLE_SCHEDULE }}
      }
      
      @if (!confirmRechargeSchedule) {
        {{ data?.statusCode !== 'FORW00' ? textTokens.TICKET_TITLE : textTokens.TICKET_TITLE_PROCESS }}
      }
    </span>
  </div>
  <div class="voucher__ticket">
    <div class="voucher__tap"></div>
    <app-top-bar>
      <flame-icon class="voucher__top-bar-icon" svgIcon="bank-branch" size="xs" left></flame-icon>
      <p center class="voucher__top-bar">{{ textTokens.TICKET_TOP_BAR_TITLE }}</p>
      @if (buttonEnableCapture) {
        <flame-icon class="voucher__top-bar-icon" svgIcon="close" size="xs" (click)="quit()" right></flame-icon>
      }
    </app-top-bar>
    <div class="voucher__recharge-info">
      <p class="voucher__recharge-amount">
        {{ (isRechargeSchedule && confirmRechargeSchedule) ?
          textTokens?.TICKET_SCHEDULE_DESC :  textTokens?.TICKET_AMOUNT_DESC
        }}
        <br>

        @if (!confirmRechargeSchedule) {
          {{ textTokens?.TICKET_AMOUNT_DESC_OF }}
            <span>${{ data?.amo }} {{ data?.currency }}</span>
          {{ textTokens?.TICKET_AMOUNT_DESC_NUMBER }}
        }
        
        @if (isRechargeSchedule && confirmRechargeSchedule) {
            <span>${{ data?.amo }} {{ data?.currency }}</span> {{frecuency}}.
        }
        
      </p>
      <app-picture [type]="picture.type" [value]="picture.value" />

      <p class="voucher__recharge-company">
        @if (isRechargeSchedule && confirmRechargeSchedule) {
          {{nickName}}
        }@else {
          {{data?.biller?.name}}
        }
      </p>
      
      <p class="voucher__recharge-phone">{{data?.phone | mask: '00 0000 0000'}}</p>
      @if (data?.statusCode === 'FORW00') {
        <p class="voucher__recharge-code">{{data.statusCode}}</p>
      }
    </div>

    @if (confirmRechargeSchedule) {
    <div class="recharge-info-schedule">
      <div class="recharge-info-schedule__section1">
        <flame-icon fontIcon="information-in-a-circle" size="s"></flame-icon>
      </div>

      <div class="recharge-info-schedule__section2">
        <span class="recharge-info-schedule__section2--title">{{ textTokens?.TICKET_ALERT_TITLE }}</span>
        <div [innerHTML]="textTokens.TICKET_ALERT_DESCRIPTION"></div>
      </div>

    </div>
    }

  </div>

  @if (data?.statusCode === 'FORW00') {
  <div class="voucher__alert-message-container">
  <!-- <div class="voucher__alert-message-container"> -->
    <div class="voucher__alert-message">
      <flame-icon class="voucher__alert-message-icon" svgIcon="circle-attention" size="xs"></flame-icon>
      <div class="voucher__alert-message-text">
        <p class="message__title">{{ textTokens?.TICKET__ALERT_TITLE }}</p>
        <p class="message__text">{{ textTokens?.TICKET__ALERT_MESSAGE }}</p>
      </div>
    </div>
  </div>
  }

  <!-- <div class="voucher__alert-message-container"> -->
  @if (data?.statusCode === '-17') {
  <div class="voucher__alert-message-container">
    <div class="voucher__alert-message">
      <flame-icon class="voucher__alert-message-icon" svgIcon="circle-attention" size="xs"></flame-icon>
      <div class="voucher__alert-message-text">
        <p class="message__title">Tu recarga está en proceso</p>
        <p class="message__text">Tu recarga se realizará en cuanto el servicio se reactive.</p>
      </div>
    </div>
  </div>
  }

  <div class="divider">
    <div class="divider__circle-left"></div>
    <div class="divider__line"></div>
    <div class="divider__circle-right"></div>
  </div>
  <div class="voucher__data" [ngClass]="{ 'voucher__data--no-ref': data?.statusCode === 'FORW00'}">

    <p class="voucher__label">{{ textTokens.TICKET_TRANSFER_DATE }}</p>
    <p class="voucher__content">{{ data?.do | date: 'dd/MMMM/yy - HH:mm' }}</p>

    @if (confirmRechargeSchedule) {
      <p class="voucher__label">Número de teléfono</p>
      <p class="voucher__content">{{ data?.phone }}</p>
    }

    <p class="voucher__label">{{ textTokens.TICKET_ORIGIN_ACC }}</p>
    <p class="voucher__content">{{ this.data.cta }}</p>

    @if (nextRechargeDate && confirmRechargeSchedule) {
      <p class="voucher__label">{{ textTokens.TICKET_NEXT_RECHARGE }}</p>
      <p class="voucher__content">{{ nextRechargeDate }}</p>
    }
    
    <!-- <p class="voucher__label">{{ textTokens.TICKET_CONCEPT }}</p>
    <p class="voucher__content">{{ textTokens.TICKET_CONCEPT_VALUE }}</p> -->

    @if (buttonEnableCapture) {
      <p class="voucher__label">{{ textTokens.TICKET_STATUS }}</p>
      <p class="voucher__content" [ngClass]="data?.statusCode === 'FORW00' ? 'process' : 'success'">
        {{ data?.statusCode === 'FORW00' ? 'En proceso' : 'Exitoso' }}
      </p>
    }

    @if (data?.statusCode !== 'FORW00') {
      <p class="voucher__label">
        {{ data.confirmRechargeSchedule ? textTokens.TICKET_REF : textTokens?.TICKET_FOLIO }}
      </p>
      <p class="voucher__content">{{ data?.folio }}</p>
    }


    <!-- <p class="voucher__label extend">{{ textTokens.TICKET_COMISION }}</p> -->
    <p class="voucher__content">
    </p>
  </div>

  <div class="divider">
    <div class="divider__circle-left"></div>
    <div class="divider__line"></div>
    <div class="divider__circle-right"></div>
  </div>

  <div class="voucher__buttons">

    @if (buttonEnableCapture) {
      <div class="icon-btn mr-small">
        <button class="icon-btn__btn icon-btn__btn--grey" (click)="screenshot()">
          <flame-icon  svgIcon="share"></flame-icon>
        </button>
        <p class="icon-btn__text">{{ textTokens.TICKET_SHARE }}<br>{{ textTokens.TICKET_SHARE_VOUCHER }}</p>
      </div>
    }

    @if (confirmRechargeSchedule) {
      <div class="icon-btn mr-small">
        <button class="icon-btn__btn icon-btn__btn--grey" (click)="openNewRecharge()">
          <flame-icon  svgIcon="mobile"></flame-icon>
        </button>
        <p class="icon-btn__text">Recargar<br>otro número</p>
      </div>
    }

    @if (isRechargeSchedule && !confirmRechargeSchedule) {
      <div class="icon-btn mr-small">
        <button class="icon-btn__btn icon-btn__btn--red" (click)="openRechargeSchedule()">
          <flame-icon  svgIcon="card-postpone-liquidation"></flame-icon>
        </button>
        <p class="icon-btn__text">Recarga<br>automática</p>
      </div>
    }

    <!-- div class="icon-btn" *ngIf="buttonEnableCapture" >
      <button class="icon-btn__btn icon-btn__btn--red" (click)="continue()">
        <img ngSrc="assets/images/cellphone.svg" alt="icon button" height="24" width="24">
      </button>
      <p class="icon-btn__text">{{ textTokens.TICKET_MAKE }}<br>{{ textTokens.TICKET_MAKE_RECHARGE }}</p>
    </div -->

  </div>
</div>
